var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',[_c('a',{on:{"click":_vm.getFile}},[_vm._v("\n    "+_vm._s(_vm.data.fileName)+"\n  ")]),_vm._v(" "),(_vm.loading)?_c('v-progress-circular',{staticClass:"ml-2",staticStyle:{"width":"14px","height":"14px"},attrs:{"indeterminate":"","color":"primary"}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-833a8724","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/FileType.vue
// module id = null
// module chunks = 